import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getData, getIsAcceptingQuotation } from '../../../data/followup/selectors/followup';
import { bindActionCreators } from 'redux';
import { cancelAcceptQuotation, acceptQuotation } from '../../../data/followup/actions/followup';
import AcceptQuotationForm from '../../followup/components/AcceptQuotationForm';

class AcceptQuotationFormContainer extends Component {
    static propTypes = {
        data: PropTypes.object,
        isLoading: PropTypes.bool,
        acceptQuotation: PropTypes.func,
        cancelAcceptQuotation: PropTypes.func
    };

    handleSubmit() {
        this.props.acceptQuotation();
    }

    handleClickCancel() {
        this.props.cancelAcceptQuotation();
    }

    render() {
        const { data, isLoading } = this.props;

        return (
            <AcceptQuotationForm
                data={data}
                isLoading={isLoading}
                onSubmit={::this.handleSubmit}
                onClickCancel={::this.handleClickCancel}
            />
        );
    }
}

export default connect(
    state => ({
        data: getData(state.followup),
        isLoading: getIsAcceptingQuotation(state.followup)
    }),
    dispatch => bindActionCreators({ acceptQuotation, cancelAcceptQuotation }, dispatch)
)(AcceptQuotationFormContainer);
